import { render, staticRenderFns } from "./ximalaya-audio-info.vue?vue&type=template&id=21a4f581&scoped=true&"
import script from "./ximalaya-audio-info.vue?vue&type=script&lang=js&"
export * from "./ximalaya-audio-info.vue?vue&type=script&lang=js&"
import style0 from "./ximalaya-audio-info.vue?vue&type=style&index=0&id=21a4f581&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a4f581",
  null
  
)

export default component.exports